"use client"

import { useInfiniteQuery } from "@tanstack/react-query"
import { listCompatiblePhoneNumberLoanTenantsAction } from "@/server-actions/phone-number-loans"
import type { CompatibleLoanTenantPage } from "@/lib/voice/phone-number-loans"

export const compatiblePhoneNumberLoanTenantsQueryKey = (search: string) => [
  "compatible-phone-number-loan-tenants",
  { search },
] as const

export function useCompatiblePhoneNumberLoanTenantsQuery(input: { enabled: boolean; search: string }) {
  return useInfiniteQuery({
    queryKey: compatiblePhoneNumberLoanTenantsQueryKey(input.search),
    enabled: input.enabled,
    initialPageParam: 0,
    queryFn: async ({ pageParam }): Promise<CompatibleLoanTenantPage> => {
      const result = await listCompatiblePhoneNumberLoanTenantsAction({
        search: input.search || undefined,
        offset: pageParam,
        limit: 25,
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    getNextPageParam: (lastPage) => lastPage.nextOffset ?? undefined,
  })
}
